import { type MultiRowSelectOptionsConfig } from "../types"

export const defaultOptionsConfig: MultiRowSelectOptionsConfig = [
  {
    label: "All records",
    checked: "CHECKED",
    key: "ALL_RECORDS",
  },
  { label: "All in view", checked: "CHECKED", key: "ALL_IN_VIEW" },
  { label: "None", checked: "UNCHECKED", key: "NONE" },
]
